import { setAccountRole, markFreelanceCoach } from './roles';
import { markFirstLoginIfNeeded } from './mobileAppLinks';

export const PROFILE_SELECT_TOKEN_KEY = 'profileSelectToken';
export const PENDING_PROFILES_KEY = 'pendingProfiles';
export const PROFILES_KEY = 'profiles';
export const CURRENT_PROFILE_KEY = 'currentProfile';

export function applySessionPayload(data) {
    if (!data?.token) return;
    localStorage.setItem('token', data.token);
    localStorage.setItem('username', data.username ?? '');
    localStorage.setItem('userId', String(data.userId ?? ''));
    if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('emailVerified', data.emailVerified ? 'true' : 'false');
    if (data.email) localStorage.setItem('userEmail', data.email);
    else localStorage.removeItem('userEmail');
    if (data.sportTypeId != null) localStorage.setItem('sportTypeId', String(data.sportTypeId));
    if (data.sportType != null) localStorage.setItem('sportType', data.sportType);
    if (data.sportIcon != null) localStorage.setItem('sportIcon', data.sportIcon);
    if (data.role) {
        setAccountRole(data.role);
        localStorage.setItem('role', data.role);
    }
    if (data.profileId != null) localStorage.setItem('profileId', String(data.profileId));
    if (data.profileType) localStorage.setItem('profileType', data.profileType);
    if (data.isBilling != null) localStorage.setItem('isBilling', data.isBilling ? 'true' : 'false');
    if (data.schoolId != null) localStorage.setItem('profileSchoolId', String(data.schoolId));
    if (data.isFreelance) markFreelanceCoach();
    else if (data.isFreelance === false) localStorage.removeItem('isFreelance');
    markFirstLoginIfNeeded();
}

export function storePendingProfileSelection(data) {
    if (data.profileSelectToken) {
        sessionStorage.setItem(PROFILE_SELECT_TOKEN_KEY, data.profileSelectToken);
    }
    sessionStorage.setItem(PENDING_PROFILES_KEY, JSON.stringify(data.profiles || []));
    if (data.userId != null) sessionStorage.setItem('pendingUserId', String(data.userId));
    if (data.username) sessionStorage.setItem('pendingUsername', data.username);
}

export function clearPendingProfileSelection() {
    sessionStorage.removeItem(PROFILE_SELECT_TOKEN_KEY);
    sessionStorage.removeItem(PENDING_PROFILES_KEY);
    sessionStorage.removeItem('pendingUserId');
    sessionStorage.removeItem('pendingUsername');
}

export function getPendingProfiles() {
    try {
        const raw = sessionStorage.getItem(PENDING_PROFILES_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export function saveProfilesList(profiles) {
    localStorage.setItem(PROFILES_KEY, JSON.stringify(profiles));
}

export function getStoredProfiles() {
    try {
        const raw = localStorage.getItem(PROFILES_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export function saveCurrentProfile(profile) {
    if (profile) localStorage.setItem(CURRENT_PROFILE_KEY, JSON.stringify(profile));
}

export function getCurrentProfile() {
    try {
        const raw = localStorage.getItem(CURRENT_PROFILE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

/** @returns {boolean} true if redirected */
export function redirectAfterAuth(data, redirectPath = '/') {
    if (data.requirePasswordChange) {
        sessionStorage.setItem('changePasswordToken', data.changePasswordToken);
        window.location.href = '/change-password';
        return true;
    }
    if (data.requireProfileSelect) {
        if (data.profiles?.length) {
            storePendingProfileSelection(data);
            sessionStorage.setItem('postProfileRedirect', redirectPath);
            window.location.href = '/select-profile';
            return true;
        }
        if (data.profileSelectToken) {
            storePendingProfileSelection({ ...data, profiles: data.profiles || [] });
            sessionStorage.setItem('postProfileRedirect', redirectPath);
            window.location.href = '/select-profile';
            return true;
        }
    }
    if (!data?.token) {
        return false;
    }
    applySessionPayload(data);
    localStorage.removeItem('activeSchool');
    if (data.profiles?.length) saveProfilesList(data.profiles);
    window.location.href = redirectPath || '/';
    return true;
}

export async function selectProfileApi(profileId, axios, apiBase) {
    const selectToken = sessionStorage.getItem(PROFILE_SELECT_TOKEN_KEY);
    const mainToken = localStorage.getItem('token');
    const token = selectToken || mainToken;
    const res = await axios.post(
        `${apiBase}/auth/select-profile`,
        { profileId },
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    const pending = getPendingProfiles();
    const stored = getStoredProfiles();
    const list = pending.length ? pending : stored;
    clearPendingProfileSelection();
    applySessionPayload(res.data);
    localStorage.removeItem('activeSchool');
    if (list.length) saveProfilesList(list);
    const active = list.find((p) => p.id === profileId) || {
        id: res.data.profileId,
        type: res.data.profileType,
        isBilling: res.data.isBilling,
        schoolName: res.data.schoolName,
        childName: res.data.childName
    };
    saveCurrentProfile(active);
    return res.data;
}
